<template>
  <vs-card>
   <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving" @change="filesChange($event.target.name, $event.target.files)">
        <h1>Upload industry data</h1>
        <div class="dropbox">
          <input type="file" :value="file" :name="uploadFieldName" :disabled="isSaving" 
            accept=".xlsx" class="input-file">
            <p v-if="isInitial">
              Drag your file here to upload industry and re-initiate model<br> or click to browse
            </p>
            <p v-if="isSaving">
              Uploading file...
            </p>
        </div>
      </form>
    <vs-popup
      class="holamundo"
      small
      title="Upload?"
      :active.sync="uploadPopup"
    >
      <p>Are you sure you want to upload {{uploadFileName}}?</p>
      <div>
        <vs-button @click="save">Upload</vs-button>
        <vs-button
          color="grey"
          style="margin-left: 15px;"
          @click="reset()"
          >Cancel</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo"
      small
      title="Re-Initiate?"
      :active.sync="reinitiateModelPopup"
    >
      <p>Start re-initiate model with industry data of {{uploadFileName}}?</p>
      <div>
       <vs-button @click="reInitiate(uploadFileName)" >Re-Initiate</vs-button>
        <vs-button
          color="grey"
          style="margin-left: 15px;"
          @click="reinitiateModelPopup = false"
          >Cancel</vs-button
        >
      </div>
    </vs-popup>
  </vs-card>
</template>
<script>
import api from "@/rest.js";
import { API } from '../../../common/constants';

  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

  export default {
    name: 'upload-industry',
    data() {
      return {
        uploadedFile: [],
        currentStatus: null,
        uploadFieldName: 'excel',
        uploadFileName: '',
        uploadPopup: false,
        formData: {},
        file: null,
        reinitiateModelPopup: false,
        reinitiateComplete: false,
      }
    },
    watch:{
      reinitiateModelPopup(value){
        if(!value){
          if(!this.reinitiateComplete)
            this.resetUpload();
          this.reset();
        }
      }
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      }
    },
    methods: {
      reset() {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL;
        this.uploadedFile = [];
        this.uploadPopup = false;
        this.formData = {};
        this.file = null;
        this.reinitiateComplete = false;
      },
      resetUpload() {
        // reset form to initial state
        this.reinitiateModelPopup = false;
        this.$vs.loading();
        api.
          post(
            API.RESET_INDUSTRY_DATA)
          .then(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              text: "Uploaded file reset to default Industry Data",
              color: "success",
              position: "top-right",
            });
            this.reset();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: "Default file upload failed, please upload the correct file manually",
              color: "danger",
              position: "top-right"
            });
            this.reset();
          });
      },
      reInitiate(event) {
        this.$vs.loading();
        api.
          post(
            API.REINITIATE_MODEL,{traintype : event}
            )
          .then(() => {
            this.reinitiateComplete = true;
            this.$vs.loading.close();
            this.reinitiateModelPopup = false;
            this.$vs.notify({
              title: "Success",
              text: "Model reinitiated Successfully",
              color: "success",
              position: "top-right",
            });
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: "Model reinitiation failed, please contact Maintainance team.",
              color: "danger",
              position: "top-right"
            });
          });
      },
      save() {
        // upload data to the server
        this.uploadPopup = false;
        this.$vs.loading();
        this.currentStatus = STATUS_SAVING;
        api.
          post(
            API.UPLOAD_INDUSTRY_DATA,
            this.formData)
          .then(x => {
            this.uploadedFile = [].concat(x);
            this.currentStatus = STATUS_SUCCESS;
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              text: "File uploaded Successfully",
              color: "success",
              position: "top-right",
            });

            this.reset();
            this.reinitiateModelPopup = true;
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.reset();
            this.$vs.notify({
              title: "Error",
              text: err.response? err.response.data.message: "File upload failed: "+ err,
              color: "danger",
              position: "top-right"
            });
          });
      },
      filesChange(fieldName, fileList) {
        // handle file changes 
        this.formData = new FormData();

        if (!fileList.length) return;        
        if (fileList.length > 1) {        
          this.$vs.notify({
            title: "File Upload failed",
            text: "You cannot add multiple files",
            color: "danger",
            position: "top-right"
          });
        }
        this.formData.append(fieldName, fileList[0], fileList[0].name);
        this.uploadFileName = fileList[0].name;
        // save it
        this.uploadPopup = true
      }
    },
    mounted() {
      this.reset();
    },
  }

</script>

<style lang="scss">
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }
  
  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }
  
  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }
  
  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
</style>
